module.exports = __webpack_public_path__ + "static/media/search_iteration_surveys_3.9da0f2e6.png";